import { render } from "./ShareSchedule.vue?vue&type=template&id=6b25c5a8&ts=true"
import script from "./ShareSchedule.vue?vue&type=script&lang=ts"
export * from "./ShareSchedule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__